const initialState = {
    scheduleBookingLists: [],
    scheduleBookingStatus: [],
    scheduleBookingPermissions: {},
    changedScheduleBookingStatus : [],
    loadingScheduleBooking: false,
    errorsScheduleBooking: {},
    scheduleBookingCount:0,
}

const  scheduleBookingReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_SCHEDULE_BOOKING_LIST_PENDING":
        case "ADD_SCHEDULE_BOOKING_PENDING":
        case "UPDATE_SCHEDULE_BOOKING_PENDING":
        case "UPDATE_SCHEDULE_BOOKING_STATUS_PENDING":
        case "DELETE_SCHEDULE_BOOKING_PENDING":
        case "GET_SCHEDULE_BOOKING_LISTBYID_PENDING":
            return { ...state, loadingScheduleBooking: true };

        case "GET_SCHEDULE_BOOKING_LIST_FULFILLED":
            return {
                ...state,
                loadingScheduleBooking: false,
                scheduleBookingLists: action.payload,
                scheduleBookingCount: action.scheduleBookingCount,
                scheduleBookingPermissions:action.permissions,
            };

        case "ADD_SCHEDULE_BOOKING_FULFILLED":
            return {
                ...state,
                loadingScheduleBooking: false,
                changedScheduleBookingStatus: action.payload,
            };

        case "UPDATE_SCHEDULE_BOOKING_FULFILLED":
            return {
                ...state,
                loadingScheduleBooking: false,
                changedScheduleBookingStatus: action.payload,
            };

        case "UPDATE_SCHEDULE_BOOKING_STATUS_FULFILLED":
            return {
                ...state,
                loadingScheduleBooking: false,
                changedScheduleBookingStatus: action.payload,
            };

        case "GET_SCHEDULE_BOOKING_LISTBYID_FULFILLED":
            return {
                ...state,
                loadingScheduleBooking: false,
                scheduleBookingLists: action.payload
            };

        case "DELETE_SCHEDULE_BOOKING_FULFILLED":
            return {
                ...state,
                loadingScheduleBooking: false,
                changedScheduleBookingStatus: action.payload
            };

        case "RESET_DELETE_SCHEDULE_BOOKING_STATUS":
            return {
                ...state,
                loadingScheduleBooking: false,
                changedScheduleBookingStatus: [],
                errorsScheduleBooking:{}
            };

        case "GET_SCHEDULE_BOOKING_LIST_REJECTED":
        case "ADD_SCHEDULE_BOOKING_REJECTED":
        case "UPDATE_SCHEDULE_BOOKING_REJECTED":
        case "UPDATE_SCHEDULE_BOOKING_STATUS_REJECTED":
        case "DELETE_SCHEDULE_BOOKING_REJECTED":
        case "GET_SCHEDULE_BOOKING_LISTBYID_REJECTED":
            return {
                ...state,
                loadingScheduleBooking: false,
                errorsScheduleBooking: action.payload
            };

        default:
            return state;
    }
}

export default scheduleBookingReducer;
